import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { Box } from '@mui/material';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { PagesList } from '../../react-elements/pages-list';
import { render_tab, } from '../cool-settings-dialog';
export const SettingMediumInterface = memo(function SettingMediumInterface(props) {
    const { pages, selected_tab, onSelectTab, volatile_data, onChangeState } = props;
    return (_jsxs(Box, { display: "grid", boxSizing: "border-box", gridTemplateColumns: "25% 1fr", width: "100%", overflow: "hidden", children: [_jsx(Box, { sx: {
                    bgcolor: 'background.default',
                    borderRight: 1,
                    borderColor: 'divider',
                    overflow: 'auto',
                }, children: _jsx(ErrorBoundary, { children: _jsx(PagesList, { dividers: false, chevrons: false, pages: pages, changeSelectedTab: onSelectTab }) }) }), _jsx(Box, { px: 2, height: "100%", overflow: "auto", children: _jsx(ErrorBoundary, { children: selected_tab != null
                        ? render_tab(selected_tab, volatile_data, onChangeState)
                        : null }) })] }));
});
